var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#004A96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.99974C11.3336 9.13603 11.2861 9.26812 11.1992 9.37307L8.2825 12.8731C8.18348 12.9922 8.0412 13.0671 7.88695 13.0813C7.7327 13.0956 7.57912 13.0479 7.46 12.9489C7.34087 12.8499 7.26596 12.7076 7.25174 12.5534C7.23751 12.3991 7.28515 12.2455 7.38416 12.1264L9.9975 8.99974L7.4775 5.87307C7.42904 5.8134 7.39286 5.74475 7.37102 5.67105C7.34919 5.59735 7.34213 5.52006 7.35026 5.44363C7.3584 5.3672 7.38155 5.29312 7.4184 5.22567C7.45525 5.15822 7.50507 5.09871 7.565 5.05057C7.62498 4.99715 7.69534 4.95669 7.77169 4.93173C7.84803 4.90676 7.9287 4.89784 8.00866 4.9055C8.08861 4.91317 8.16612 4.93727 8.23633 4.97628C8.30654 5.0153 8.36793 5.06839 8.41666 5.13224L11.2342 8.63224C11.3074 8.7402 11.3423 8.8696 11.3333 8.99974Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundArrow);
export default __webpack_public_path__ + "static/media/roundArrow.ecdb16d4.svg";
export { ForwardRef as ReactComponent };